var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb",
    clipPath: "url(#clip0_319_20603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 8.30615C8.86667 7.72282 9.15833 7.31449 9.625 6.84782C10.2083 6.32282 10.5 5.56449 10.5 4.80615C10.5 3.87789 10.1313 2.98766 9.47487 2.33128C8.8185 1.6749 7.92826 1.30615 7 1.30615C6.07174 1.30615 5.1815 1.6749 4.52513 2.33128C3.86875 2.98766 3.5 3.87789 3.5 4.80615C3.5 5.38949 3.61667 6.08949 4.375 6.84782C4.78333 7.25615 5.13333 7.72282 5.25 8.30615",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.25 10.6396H8.75",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83301 12.9731H8.16634",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_20603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.139648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.047605131129a727e2be39d3562699a3.svg";
export { ForwardRef as ReactComponent };